<div class="example-container" [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="example-toolbar mat-elevation-z6">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <h2>{{ title }}</h2>
    <h5 class="m-b-0">{{ version.lib }}</h5>
  </mat-toolbar>

  <mat-sidenav-container
    class="example-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 48 : 0"
  >
    <mat-sidenav
      #snav
      opened="true"
      [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches"
      fixedTopGap="48"
    >
      <mat-accordion displayMode="flat" multi>
        @for (routeConfig of routesConfig; track routeConfig) {
          @if (!routeConfig.children) {
            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="routeConfig.path"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active-link"
                class="p-h-24 m-t-8"
                >{{ routeConfig.title }}</a
              >
            </mat-nav-list>
            <mat-divider />
          } @else {
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title> {{ routeConfig.title }} </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                @for (route of routeConfig.children; track route) {
                  <a
                    mat-list-item
                    [routerLink]="routeConfig.path + '/' + route.path"
                    routerLinkActive="active-link"
                    >{{ route.title }}</a
                  >
                }
              </mat-nav-list>
            </mat-expansion-panel>
            <mat-divider />
          }
        }
      </mat-accordion>
    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet />
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
